import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-list-view-container',
    templateUrl: './list-view-container.component.html',
    styleUrls: ['./list-view-container.component.scss'],
    standalone: false,
})
export class ListViewContainerComponent {
}
